import { registerFooterComponent } from '@/composables/useCommandBar/customComponents/components/footer/footer'

export const registerCustomComponents = (): void => {
  registerFooterComponent()
}
